import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t" style={{ borderColor: "var(--mn-glass-border)", background: "var(--mn-bg2)" }} data-testid="footer">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={40} />
            <div>
              <p className="font-serif text-xl">Mother Nature</p>
              <p className="font-mono text-[0.55rem] uppercase tracking-[0.3em]" style={{ color: "var(--mn-gold)" }}>
                Ancient wisdom · Modern science
              </p>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed" style={{ color: "var(--mn-text2)" }}>
            Founded in 2025 by Kiran Ben Vadher, a beautician from Sihor, Gujarat — heritage botanicals and science-backed actives, crafted with clinical precision and a hometown heart.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4">Shop</p>
          <ul className="space-y-2 text-sm" style={{ color: "var(--mn-text2)" }}>
            <li><Link data-testid="footer-link-shop" className="transition-colors hover:text-[var(--mn-gold)]" to="/shop">Shop All Formulas</Link></li>
            <li><Link data-testid="footer-link-gift-set" className="transition-colors hover:text-[var(--mn-gold)]" to="/product/utsav-diwali-radiance-gift-set">Diwali Gift Set</Link></li>
            <li><Link data-testid="footer-link-bestsellers" className="transition-colors hover:text-[var(--mn-gold)]" to="/shop?sort=popular">Bestsellers</Link></li>
            <li><Link data-testid="footer-link-quiz" className="transition-colors hover:text-[var(--mn-gold)]" to="/quiz">AI Skin Quiz</Link></li>
            <li><Link data-testid="footer-link-track" className="transition-colors hover:text-[var(--mn-gold)]" to="/track">Track Your Order</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">House</p>
          <ul className="space-y-2 text-sm" style={{ color: "var(--mn-text2)" }}>
            <li><Link data-testid="footer-link-about" className="transition-colors hover:text-[var(--mn-gold)]" to="/about">Our Story</Link></li>
            <li><Link data-testid="footer-link-ingredients" className="transition-colors hover:text-[var(--mn-gold)]" to="/about#sourcing">Ethical Sourcing</Link></li>
            <li><span>AYUSH Certified · GMP Facility</span></li>
            <li><span>Dermatologist Tested</span></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Concierge</p>
          <ul className="space-y-2 text-sm" style={{ color: "var(--mn-text2)" }}>
            <li><a data-testid="footer-phone-1" className="transition-colors hover:text-[var(--mn-gold)]" href="tel:+919662893341">+91 96628 93341</a></li>
            <li><a data-testid="footer-phone-2" className="transition-colors hover:text-[var(--mn-gold)]" href="tel:+917041442765">+91 70414 42765 (WhatsApp)</a></li>
            <li className="text-xs leading-relaxed">Bhavnagar–Rajkot Road, near PNB Bank,<br />opposite Shivalik Prime, Sihor, Gujarat</li>
            <li><a data-testid="footer-instagram" className="transition-colors hover:text-[var(--mn-gold)]" href="https://instagram.com/mothernature_official" target="_blank" rel="noopener noreferrer">@mothernature_official</a></li>
            <li className="font-mono text-xs" style={{ color: "var(--mn-mint)" }}>UPI · Cards · Net Banking · COD</li>
          </ul>
        </div>
      </div>
      <div className="border-t px-4 py-5 text-center font-mono text-[0.65rem] uppercase tracking-[0.25em]" style={{ borderColor: "var(--mn-glass-border)", color: "var(--mn-text2)" }}>
        © 2026 Mother Nature Botanicals Pvt. Ltd. · Made in India
      </div>
    </footer>
  );
}
